import React from 'react';
import { Link } from 'react-router-dom';
import bem from 'utils/bem';
import useCart from 'components/CartWidget/useCart';
import Icon from 'components/Icon';
import Text from 'components/Text';
import TeaserPhoto from 'components/TeaserPhoto';
import { formatPrice } from 'utils/format';
import Counter from '../../ShopItem/CartButton/Counter'
import './index.sass';
import { Skeleton } from '@mui/material';
import item from '../../ShopItem/Item';

const { block, el } = bem('cart-item');

const CartItem = ({ item }) => {
    const { updateItem, removeItem } = useCart(item.id)

    const onTrashBinClick = (e) => {
        e.preventDefault();
        removeItem();
    };

    const noItem = !item.data;
    if (noItem) {
        return <div className={block({disabled: true})}>
            <div className={ el('left-block') }>
                <div className={ el('photo') }>
                </div>
                <div className={ el('title') }>
                </div>
            </div>
            <div className={ el('right-block') }>
                <div className={ el('price') }>
                </div>
                <div className={ el('counter') }>
                    <Counter amount={ item.cartAmount } updateItem={ updateItem } maxAmount={ item.cartAmount }/>
                </div>
                <div className={ el('no-buy-text') }>
                    <Text>Товар недоступен для покупки</Text>
                </div>
                <Icon className={ el('trash-icon') } name={ 'trash' } onClick={ onTrashBinClick }/>
            </div>
        </div>
    }

    const outOfStock = item.data.amount === 0 ;
    return <Link to={ `/goods/${ item.data.url }` } className={ block({ disabled: outOfStock }) }>
        <div className={ el('left-block') }>
            <div className={ el('photo') }>
                <TeaserPhoto src={ item.photo }/>
            </div>
            <div className={ el('title') }>
                <Text serif>{ item.data.name }</Text>
            </div>
        </div>
        <div className={ el('right-block') }>
            <div className={ el('price') }>
                <Text>{ formatPrice(item.data.price) }</Text>
            </div>
            { !outOfStock && <div className={ el('counter') }>
                <Counter amount={ item.cartAmount } updateItem={ updateItem } maxAmount={ item.data.amount }/>
            </div> }
            { outOfStock && <div className={ el('no-buy-text') }>
                <Text>Товар недоступен для покупки</Text>
            </div> }
            <Icon className={ el('trash-icon') } name={ 'trash' } onClick={ onTrashBinClick }/>
        </div>
    </Link>
}

export const DesktopCartItemSkeleton = () => {
    return (
        <div className={ block() }>
            <div className={ el('left-block') }>
                <div className={ el('photo') }>
                    <div><Skeleton variant={'rounded'} style={{borderRadius: '10px', paddingTop: '100%'}} /></div>
                </div>
                <div className={ el('title') }>
                    <Text serif><Skeleton width={300}/></Text>
                </div>
            </div>
            <div className={ el('right-block') }>
                <div className={ el('price') }>
                    <Text><Skeleton width={100} /></Text>
                </div>
                <div className={ el('counter') }>
                    <Skeleton variant={'rounded'} width={100} style={{borderRadius: '10px'}}/>
                </div>
            </div>
        </div>
    )
}

export default CartItem;
